"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ = _interopRequireDefault(require(".."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @exports Logger
 */
var Logger = /*#__PURE__*/function () {
  function Logger() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scout';

    _classCallCheck(this, Logger);

    this.name = name;
  }
  /**
   * 打印信息
   * 
   * @private
   * @param {'error'|'info'|'warn'} level - 日志类型
   * @param {string} msg - 日志内容
   */


  _createClass(Logger, [{
    key: "log",
    value: function log() {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';
      var msg = arguments.length > 1 ? arguments[1] : undefined;
      if (!_["default"].options.testMode) return;
      var prefix = "[".concat(this.genTimeStamp(), "]") + " [".concat(level.toUpperCase(), "] ") + this.name + ' - ';
      msg = prefix + msg;

      for (var _len = arguments.length, substrs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        substrs[_key - 2] = arguments[_key];
      }

      if (console[level]) {
        var _console;

        (_console = console)[level].apply(_console, [msg].concat(substrs));
      } else {
        var _console2;

        (_console2 = console).log.apply(_console2, [msg].concat(substrs));
      }
    }
    /**
     * 生成时间戳
     * 
     * @private
     * @returns {string}
     * 
     * @example
     * 2019-10-23 11:32:58.648
     */

  }, {
    key: "genTimeStamp",
    value: function genTimeStamp() {
      var dateInst = new Date();
      var year = dateInst.getFullYear();
      var month = this.padStartWithZero(dateInst.getMonth() + 1, 2);
      var date = this.padStartWithZero(dateInst.getDate(), 2);
      var hours = this.padStartWithZero(dateInst.getHours(), 2);
      var minutes = this.padStartWithZero(dateInst.getMinutes(), 2);
      var seconds = this.padStartWithZero(dateInst.getSeconds(), 2);
      var milliseconds = this.padStartWithZero(dateInst.getMilliseconds(), 2);
      return "".concat(year, "-").concat(month, "-").concat(date, " ").concat(hours, ":").concat(minutes, ":").concat(seconds, ".").concat(milliseconds);
    }
    /**
     * 数字前面补零
     * 
     * @private
     * @param {number} num
     * @param {number} len - 展示位数
     * @returns {string}
     */

  }, {
    key: "padStartWithZero",
    value: function padStartWithZero(num, targetLength) {
      num = String(num);
      var len = num.length;

      while (len < targetLength) {
        num = '0' + num;
        len++;
      }

      return num;
    }
    /**
     * 错误级别
     * 
     * @public
     * @param {string} msg - 日志内容
     */

  }, {
    key: "error",
    value: function error(msg) {
      for (var _len2 = arguments.length, substrs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        substrs[_key2 - 1] = arguments[_key2];
      }

      this.log.apply(this, ['error', msg].concat(substrs));
    }
    /**
     * 信息级别
     * 
     * @public
     * @param {string} msg - 日志内容
     */

  }, {
    key: "info",
    value: function info(msg) {
      for (var _len3 = arguments.length, substrs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        substrs[_key3 - 1] = arguments[_key3];
      }

      this.log.apply(this, ['info', msg].concat(substrs));
    }
    /**
     * 警告级别
     * 
     * @public
     * @param {string} msg - 日志内容
     */

  }, {
    key: "warn",
    value: function warn(msg) {
      for (var _len4 = arguments.length, substrs = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        substrs[_key4 - 1] = arguments[_key4];
      }

      this.log.apply(this, ['warn', msg].concat(substrs));
    }
  }]);

  return Logger;
}();

exports["default"] = Logger;